import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {PaymentFailedIcon} from "../../../../SVGElements";
import {Messages} from "../../../../Messages";
import {donateMobileState} from "../../../inline-donation/DonateMobileState";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_DONATION_URLS} from "../../../PanelConstants";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {paymentMethodController} from "../../../inline-donation/PaymentMethodController";


export class DonationFailedPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: iFrameMerchantService.isMerchant(TNR_ALIAS) ? "left" : "center",
    };

    @styleRule
    icon = {
        marginBottom: 14,
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(DonationFailedPanelStyle)
export class DonationFailedPanel extends BasePanelPage {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        formattedMessage += " ";

        return formattedMessage;
    }

    render() {
        const {styleSheet} = this;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <PaymentFailedIcon className={styleSheet.icon} color={styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div testId="donateFailedTitle" className={styleSheet.title + (iFrameMerchantService.isMerchant(TNR_ALIAS) ? styleSheet.leftAlign : "")}>
                {Messages.donatePaymentFailed}
            </div>,
            <div testId="donateFailedMessage" className={styleSheet.message}>
                {paymentMethodController.isCDSPaymentError() && iFrameMerchantService.isMerchant(TNR_ALIAS) ?
                    [Messages.tnrContactCustomerSupport, <Link className={styleSheet.link} value={Messages.tnrContactCustomerSupportLink} href={Messages.tnrCustomerSupportLink.toString()}/>, "."] :
                    [this.formatPaymentErrorMessage(paymentMethodController.getPaymentErrorMessage()), Messages.donateFailedMessage]}
            </div>,
            <MerchantButton className={styleSheet.button} onClick={() => Router.changeURL(INLINE_DONATION_URLS.card)}>
                {Messages.editPaymentDetails}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => {
                    LoadingSpinner.show();
                    donateMobileState.donateInlineFlowDonate();
                }}>{Messages.retryPaymentDonation}</div>
            </div>,
        ];
    }

    onMount() {
        super.onMount();

        this.attachListener(paymentMethodController, () => this.redraw());
    }
}
